import {toFixedPrice} from "../jobEditPopup/jobPricingFunctions";
import Misc from "../../../misc";

/**
 * @returns {jobOrderInterface}
 * */
export const getParsedJobOrder = (job) => {
  return job.jobOrder ? JSON.parse(job.jobOrder) : {};
}

/**
 * @param jobOrder {jobOrderInterface}
 * @param jobTotal {object}
 * @param property {string}
 * @returns {number}
 * */
export const getReferralAmount = (jobOrder, jobTotal, property = "referralPercent") => {
  if (!jobOrder || !jobOrder[property] || !jobTotal) {
    return 0
  }
  return Misc.percentage(jobTotal.totalWithTaxes, jobOrder[property])
}
